import getRandomInt from '../functions/getRandomInt';
//import getRandomIntArray from '../functions/getRandomIntArray';
export default function random(type) {
    if (type === undefined) {
        type = getRandomInt(1, 3);
    }
    const biggest = getRandomInt(4, 6);
    let choices = getRandomInt(biggest + 1, 9);
    let compare;
    if (type == 1) {
        choices = 0;
        compare = getRandomInt(2, biggest - 1);
    }
    else {
        compare = getRandomInt(2, choices - 1);
    }
    return type * 1000 + biggest * 100 + compare * 10 + choices;
}
